<template>
  <div class="content-page container">
    <div v-if="!pageContent" class="empty-block"></div>
    <div v-else>
      <div class="cloud-desktop-right-top">
        <img src="../assets/images/ContentPage-right-top.png" alt="cloud" />
      </div>
      <el-row type="flex" class="about-us-main-block">
        <div class="cloud-header-image-mobile">
          <img src="../assets/images/cloud-header-mobile.png" alt="декор" />
        </div>
        <el-col :xs="24" :sm="15" :md="15" :lg="15">
          <div>
            <h1 class="about-us-main title">
              {{ pageContent.sections[0].title }}
            </h1>
            <div v-html="pageContent.sections[0].description"></div>
          </div>
        </el-col>
        <el-col
          class="about-us-main-block__col-image"
          :xs="24"
          :sm="9"
          :md="9"
          :lg="9"
        >
          <div class="about-us-main-block__image">
            <img
              :src="pageContent.sections[0].image"
              alt="image"
            />
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="ux-chaos-block" type="flex">
        <el-col :xs="24" :sm="24" :span="24">
          <div class="ux-chaos">
            <h2 class="title">{{ pageContent.sections[2].title }}</h2>
          </div>
        </el-col>
        <el-col
          class="ux-chaos-list"
          :xs="24"
          :sm="12"
          :md="8"
          :span="8"
          v-for="(item, index) in pageContent.sections[2].sections"
          :key="index"
        >
          <div class="ux-chaos-item">
            <div class="ux-chaos-item__img">
              <img alt="" :src="item.image" />
            </div>
            <div class="ux-chaos-item__title">
              <h3>{{ item.title }}</h3>
            </div>
            <div class="ux-chaos-item__info" v-html="item.description"></div>
          </div>
        </el-col>
      </el-row>
      <el-row class="ux-team-plans-block" type="flex" :gutter="20">
        <el-col :xs="24" :sm="10" :md="11">
          <div class="ux-team-img">
            <img alt="" :src="pageContent.sections[1].image" />
          </div>
        </el-col>
        <el-col :xs="24" :sm="14" :md="13">
          <div class="ux-team-content">
            <h2 class="here-title">{{ pageContent.sections[1].title }}</h2>
            <div v-html="pageContent.sections[1].description"></div>
          </div>
        </el-col>
      </el-row>
      <el-row
        class="about-us-form-container"
        justify="space-between"
        type="flex"
      >
        <el-col :xs="24" :span="5">
          <div class="about-us-form-img__left">
            <img alt="" src="@/assets/images/about-us-form-left.png" />
          </div>
          <div class="about-us-form-img__left-mobile">
            <img
              src="../assets/images/advertisement/cloud_inner_step3.png"
              alt="хмара"
            />
          </div>
          <div class="about-us-form-img__woman-mobile">
            <img
              src="../assets/images/advertisement/person_inner_step3.png"
              alt="жінка"
            />
          </div>
        </el-col>
        <el-col :xs="24" :span="14">
          <div class="about-us-form-wrapper logIn-form-wrapper">
            <div class="about-us-form__title">
              <h2 class="title">{{ formContent.title }}</h2>
              <p
                class="about-us__subTitle"
                v-html="formContent.description"
              ></p>
            </div>
            <!--            // Rule Form-->
            <el-form :model="feedBackForm">
              <div class="logIn-form-inputs-wrapper">
                <el-form-item
                  class="custom-form-input"
                  :class="{ invalid: $v.feedBackForm.name.$error }"
                >
                  <el-input v-model="feedBackForm.name"></el-input>
                  <div class="your-label">ваше ім'я</div>
                </el-form-item>
                <el-form-item
                  class="custom-form-input"
                  :class="{ invalid: $v.feedBackForm.phone.$error }"
                >
                  <el-input
                    v-model="feedBackForm.phone"
                    minLength="10"
                    maxlength="10"
                    ><template slot="prepend">+38</template></el-input
                  >
                  <div class="your-label">ваш телефон</div>
                </el-form-item>
              </div>
              <div class="logIn-form-btn-wrapper">
                <el-form-item class="personal-info-accept" label="" prop="type">
                  <el-checkbox
                    class="checkbox"
                    v-model="personalInfoAccept"
                    name="type"
                  ></el-checkbox>
                  <span class="acceptation">Згода на обробку </span>
                  <a class="acceptation_link" href="">персональних даних</a>
                </el-form-item>
                <el-form-item>
                  <el-button
                    class="rounded-btn blue"
                    type="primary"
                    :loading="isSendingFeedBack"
                    :disabled="!personalInfoAccept"
                    @click="submitForm"
                  >
                    Відправити
                  </el-button>
                </el-form-item>
              </div>
            </el-form>
            <div
              :class="{ active: formSubmitInfo }"
              class="thx-massage-container"
            >
              <p>Дякуємо за звернення! Ми зателефонуємо найближчим часом.</p>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :span="5">
          <div class="about-us-form-img__right">
            <img alt="" src="@/assets/images/about-us-form-right.png" />
          </div>
          <div class="about-us-form-img__right-mobile">
            <img
              src="../assets/images/advertisement/cloud_inner_step3.png"
              alt="хмара"
            />
          </div>
          <div class="about-us-form-img__tree-mobile">
            <img src="../assets/images/tree-form-mobile.png" alt="дерево" />
          </div>
        </el-col>
      </el-row>
      <!--    background-->
      <div>
        <div class="main-right-top">
          <img alt="" src="@/assets/images/ContentPage-right-top.png" />
        </div>
        <div class="main-left-top">
          <img alt="" src="@/assets/images/main-left-top.png" />
        </div>
        <div class="main-right-bottom">
          <img alt="" src="@/assets/images/main-right-bottom.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { numeric, required } from 'vuelidate/lib/validators'
import { Api } from '@/services/AxiosService'
import { host } from '@/services/config'

export default {
  name: 'about-us',
  async created() {
    try {
      this.$store.dispatch('show')
      const res1 = await Api.fetchPageContentBySlug(this.$route.name)
      this.pageContent = res1.data.data
      const res2 = await Api.fetchPageContentBySlug('feedback')
      this.formContent = res2.data.data
      this.$store.dispatch('hide')
    } catch (e) {
      this.$errorMessage('Упс... Спробуйте пізніше')
    }
  },
  validations: {
    feedBackForm: {
      name: { required },
      phone: { required, numeric },
    },
  },
  data() {
    return {
      feedBackForm: {},
      personalInfoAccept: false,
      isSendingFeedBack: false,
      formSubmitInfo: false,
      pageContent: null,
      formContent: {},
      baseUrl: host,
    }
  },
  methods: {
    showFormSubmitInfo() {
      this.formSubmitInfo = true
      setTimeout(() => {
        return (this.formSubmitInfo = !this.formSubmitInfo)
      }, 4000)
    },

    async submitForm() {
      try {
        this.isSendingFeedBack = true
        this.$v.feedBackForm.$touch()
        if (this.$v.feedBackForm.$invalid) {
          return
        }
        const data = {
          ...this.feedBackForm,
          phone: '+38' + this.feedBackForm.phone,
        }
        await Api.sendFeedback(data)

        this.showFormSubmitInfo()
        this.feedBackForm = {
          phone: '',
          name: '',
        }
        this.personalInfoAccept = false
        this.$v.feedBackForm.$reset()
      } catch (e) {
      } finally {
        this.isSendingFeedBack = false
      }
    },
  },
}
</script>
